import { Column } from "primereact/column";
import { useEffect, useState } from "react";
import CatService from "../../service/CatService";
import { DataTable } from "primereact/datatable";
import { useTranslation } from "react-i18next";

export function LogGrid({catId})
{
    const {t} = useTranslation();
    const [logs,setLogs]=useState([]);
    useEffect(()=>{
        CatService.getCatLogs(catId).then((ret)=>{
            setLogs(ret);
        });
    },[]);
    return(
        <DataTable value={logs} showGridlines className="p-datatable-striped p-datatable-sm">
            <Column field="id" header={t("Id")} style={{width:'10%'}} sortable></Column>
            <Column field="actDate" header={t("Datetime")} style={{width:'20%'}} sortable
                body={(wrk)=>t('datetime.short',{val:wrk.actDate})}
            ></Column>
            <Column field="userName" header={t("User")} style={{width:'20%'}} sortable></Column>
            <Column field="action" header={t("Action")} style={{width:'20%'}} sortable></Column>
            <Column field="path" header={t("Path")} style={{width:'20%'}} sortable></Column>
            <Column field="dat" header={t("Details")} style={{width:'40%'}}></Column>
        </DataTable>
    )
}
